import React from "react";
import "./Hero.css";
import Header from "../header/Header";
import Calories from "../../assets/calories.png";
import Heart from "../../assets/heart.png";
import Hero_image from "../../assets/hero_image.png";
import Hero_image_back from "../../assets/hero_image_back.png";
import { motion } from "framer-motion";
import Numbercounter from "number-counter"

const Hero = () => {
  const transition = { type: "spring", duration: 3 };
  const mobile = window.innerWidth<=768? true: false;
  return (
    <div className="hero" id="home">
      <div className="blur hero-blur"></div>
      <div className="left-h">
        <Header />
        {/*the best ad */}
        <div className="the-best-ad">
          <motion.div
            initial={{ left: "238px" }}
            whileInView={{ left: "8px" }}
            transition={{...transition, type: 'tween'}}
          ></motion.div>
          <span>the best fitness club in the town</span>
        </div>
        {/*hero heading */}
        <div className="hero-text">
          <div>
            <span className="stroke-text">Shape </span>
            <span>Your</span>
          </div>
          <div>
            <span>Ideal Body</span>
          </div>
          <div>
            <span>
              In here we will help you to shape and build your ideal body and
              live up your life to the fullest
            </span>
          </div>
        </div>
        {/*figures */}
        <div className="figures">
          <div>
            <span>
              <Numbercounter end={140} start={100} delay='4' preFix='+'/>
            </span>
            <span>expert coaches</span>
          </div>
          <div>
            <span>
            <Numbercounter end={978} start={500} delay='4' preFix='+'/>

            </span>
            <span>members joined</span>
          </div>
          <div>
            <span><Numbercounter end={50} start={0} delay='4' preFix='+'/>
            </span>
            <span>fitness programs</span>
          </div>
        </div>
        {/*buttons */}
        <div className="hero-buttons">
          <button className="btn">Get Started</button>
          <button className="btn">Learn More</button>
        </div>
      </div>
      <div className="right-h">
        <button className="btn">Join now</button>

        <motion.div 
        whileInView={{right: '4rem'}}
        transition={transition}
        initial = {{right: '-1rem'}}

        
        className="heart-rate">
          <img src={Heart} alt="" />
          <span>Heart Rate</span>
          <span>116 bpm</span>
        </motion.div>
        {/*hero images */}
        <img src={Hero_image} alt="" className="hero-image" />
        <motion.img 
        whileInView={{right: '4rem'}}
        transition={transition}
        initial = {{right: '-1rem'}}
        src={Hero_image_back} alt="" className="hero-image-back" />
        {/**Calories */}
        <motion.div 
        whileInView={{right: '28rem'}}
        transition={transition}
        initial = {{right: '37rem'}}
        
        className="calories">
          <img src={Calories} alt="" />
          <div>
            <span>Calories Burned </span>
            <span>220 kcal</span>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
